import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ACCESS_MANAGEMENT_FEATURE_KEY } from './access-management.reducer';
import { AccessManagementState } from './access-management.models';

// Lookup the 'AccessManagement' feature state managed by NgRx
export const selectAccessManagementState = createFeatureSelector<AccessManagementState>(
  ACCESS_MANAGEMENT_FEATURE_KEY
);

export const selectSelectedTabIndex = createSelector(
  selectAccessManagementState,
  (state: AccessManagementState) => state.selectedTabIndex
);

export const selectAccessManagementLoaded = createSelector(
  selectAccessManagementState,
  (state: AccessManagementState) => state.loaded
);

export const selectAccessManagementError = createSelector(
  selectAccessManagementState,
  (state: AccessManagementState) => state.error
);